module.exports = __webpack_public_path__ + "img/eLearning_content_img_04.7d16fc57.jpg";